import { render, staticRenderFns } from "./PlantingSocExportSostamMu.vue?vue&type=template&id=dc5ce0ae"
import script from "./PlantingSocExportSostamMu.vue?vue&type=script&lang=js"
export * from "./PlantingSocExportSostamMu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports